import { render, staticRenderFns } from "./TextInfo.vue?vue&type=template&id=f1fee3e0&scoped=true&"
import script from "./TextInfo.vue?vue&type=script&lang=js&"
export * from "./TextInfo.vue?vue&type=script&lang=js&"
import style0 from "./TextInfo.vue?vue&type=style&index=0&id=f1fee3e0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1fee3e0",
  null
  
)

export default component.exports